import { parseCollections, parseFiles } from '../utils/parser';
import { fetchApi } from '../api/collectionManager';
import { getFileMetadata } from '../api/digitalVault';
import { fetchCache, getCacheKey, persistCache, parseCollectionsPagination, validateCache, } from '../utils';
const getUserCollections = async (params = {}, lcid, collectionCacheProps, logger) => {
    if (collectionCacheProps?.enableCache) {
        const key = getCacheKey({
            params,
            endpoint: `${collectionCacheProps.cacheKeyPrefix}-${lcid}/collections`,
        });
        const cacheResp = await fetchCache('user_collections', key);
        if (cacheResp) {
            const { hasNextPage, nextPageParams } = parseCollectionsPagination(cacheResp.data.links);
            return {
                hasNextPage,
                data: cacheResp.parsedFiles,
                isDataFromCache: true,
                updateCache: false,
                paginate() {
                    return (hasNextPage && getUserCollections(nextPageParams, lcid, collectionCacheProps, logger));
                },
            };
        }
    }
    return await userCollectionApi(params, lcid, collectionCacheProps, logger);
};
const userCollectionApi = async (params, lcid, collectionCacheProps, logger) => {
    let parsedFiles = [];
    let updateCache = false;
    const isDataFromCache = false;
    const urlParams = new URLSearchParams();
    const key = getCacheKey({
        params,
        endpoint: `${collectionCacheProps.cacheKeyPrefix}-${lcid}/collections`,
    });
    Object.entries(params).forEach(([key, value]) => {
        if (key === 'additionalParams' && Array.isArray(value)) {
            value.forEach((item) => {
                urlParams.append('source', item);
            });
        }
        else if (value !== undefined) {
            urlParams.append(key, value);
        }
    });
    const data = await fetchApi({}, `collections?${urlParams?.toString()}`, logger);
    const collections = data?.collections?.filter((element) => {
        return element.mediaItemsCount !== 0;
    }) || [];
    if (collections.length > 0) {
        const parsedCollectionsWithId = parseCollections(collections);
        const parsedCollections = parsedCollectionsWithId.map(({ collectionId, ...rest }) => rest);
        const collectionMetaData = await getFileMetadata(parsedCollections, logger);
        const { hasNextPage, nextPageParams } = parseCollectionsPagination(data.links);
        const parsedFilesWithNodeIds = {};
        parsedFiles = parseFiles(collectionMetaData.files);
        parsedFiles.forEach((file) => {
            parsedFilesWithNodeIds[file.nodeId] = file;
        });
        parsedFiles = parsedCollectionsWithId
            .map((file) => ({
            ...parsedFilesWithNodeIds[file.nodeId.$],
            collectionData: collections[collections?.findIndex((item) => item.id === file.collectionId)],
        }))
            .filter((element) => {
            return element.collectionData.mediaItemsCount !== 0;
        });
        const value = { url: key, data, parsedFiles };
        if (collectionCacheProps.validateCache) {
            const { dataUpdated } = await validateCache('user_collections', key, value);
            updateCache = dataUpdated;
        }
        if (collectionCacheProps?.enableCache || updateCache) {
            await persistCache('user_collections', key, value);
        }
        return {
            hasNextPage,
            data: parsedFiles,
            isDataFromCache,
            updateCache,
            paginate() {
                return (hasNextPage && getUserCollections(nextPageParams, lcid, collectionCacheProps, logger));
            },
        };
    }
    if (collectionCacheProps?.validateCache) {
        const value = { url: key, data, parsedFiles };
        const { dataUpdated } = await validateCache('user_collections', key, value);
        updateCache = dataUpdated;
        if (collectionCacheProps?.enableCache || updateCache) {
            await persistCache('user_collections', key, value);
        }
    }
    return {
        hasNextPage: false,
        data: parsedFiles,
        isDataFromCache,
        updateCache,
        paginate() {
            return null;
        },
    };
};
export default getUserCollections;
